export default "__VITE_ASSET__DxhBdTIT__"